import * as types from './types'

export const enableLoading = () => ({
    type: types.ENABLE_LOADING
})
export const disableLoading = () => ({
    type: types.DISABLE_LOADING
})
